var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveySuccess = function SvgSurveySuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 33.771,
    cy: 41.689,
    r: 33.77,
    fill: "url(#SurveySuccess_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.486.047h-.012a.1.1 0 0 0-.087.089c-.44 2.265-1.699 3.695-4.088 4.09a.1.1 0 0 0-.089.077v.001a.084.084 0 0 0-.001.009V4.327a.08.08 0 0 0 .002.023.1.1 0 0 0 .089.075c2.388.395 3.646 1.825 4.087 4.089a.1.1 0 0 0 .09.09.08.08 0 0 0 .011 0h.002a.1.1 0 0 0 .096-.09c.442-2.264 1.699-3.694 4.088-4.09a.1.1 0 0 0 .09-.087v-.002a.08.08 0 0 0 0-.012V4.31a.1.1 0 0 0-.09-.083C52.284 3.83 51.027 2.4 50.585.136a.1.1 0 0 0-.09-.09h-.011ZM17.626 12.71h-.003l-.006.001a.084.084 0 0 0-.073.075c-.37 1.902-1.428 3.103-3.434 3.435a.083.083 0 0 0-.075.065v.001a.06.06 0 0 0-.001.007v.002a.06.06 0 0 0 0 .006v.008a.11.11 0 0 0 0 .006v.002l.002.007c.009.035.039.06.074.063 2.006.332 3.063 1.533 3.434 3.435.003.04.035.071.075.075H17.63a.084.084 0 0 0 .08-.074c.372-1.903 1.428-3.104 3.434-3.436a.084.084 0 0 0 .075-.065v-.001l.001-.007v-.002a.106.106 0 0 0 .001-.01V16.3a.06.06 0 0 0 0-.008.084.084 0 0 0-.076-.07c-2.007-.332-3.063-1.533-3.434-3.435a.084.084 0 0 0-.076-.075H17.625ZM6.33 1.074h-.016a.147.147 0 0 0-.129.132C5.533 4.558 3.671 6.674.135 7.259a.147.147 0 0 0-.131.115v.001A.135.135 0 0 0 0 7.388v.003a.113.113 0 0 0 0 .017v.021l.003.013a.147.147 0 0 0 .132.111c3.534.585 5.396 2.701 6.05 6.052.006.07.061.126.131.133h.002a.121.121 0 0 0 .016 0h.003a.147.147 0 0 0 .14-.132c.655-3.352 2.516-5.468 6.052-6.054a.147.147 0 0 0 .133-.128V7.42a.116.116 0 0 0 .001-.017v-.007l-.001-.01v-.003a.147.147 0 0 0-.134-.124c-3.535-.586-5.395-2.702-6.05-6.052a.147.147 0 0 0-.132-.133H6.33Z",
    fill: "#FFEFA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.007 24.348h17.798c-.4-2.395-.958-8.214 0-12.322.958-4.107 5.305-4.563 7.701-4.278 0 4.507.582 14.273 2.91 17.285 2.327 3.012 9.64 3.88 13.006 3.936v29.436c-2.168.114-7.29.548-10.44 1.37-3.935 1.026-16.086 3.422-20.194 3.422-3.286 0-8.214-1.54-10.781-2.396-.97-.4-2.91-1.746-2.91-3.936s1.94-3.423 2.91-3.594v-.685c-1.37-.17-4.108-1.608-4.108-4.62s2.738-4.108 4.108-4.108v-.855c-1.37-.114-4.108-1.472-4.108-4.621 0-3.15 2.738-4.279 4.108-4.279v-.855c-1.54-.057-4.621-.685-4.621-4.45s3.594-4.45 4.62-4.45Z",
    fill: "url(#SurveySuccess_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.696 30.237a1.56 1.56 0 0 1 1.48-1.513l10.377-.532a1.54 1.54 0 0 1 1.63 1.44c.382 6.194 1.68 29.277-.097 30.313-1.64.958-9.728-.38-12.912-.956a1.532 1.532 0 0 1-1.255-1.56l.777-27.192Z",
    fill: "url(#SurveySuccess_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6ECFA",
    d: "M57.161 31.879h6.846v1.369h-6.846z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE3F7",
    d: "M57.161 37.355h6.846v1.369h-6.846z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8E1F5",
    d: "M57.161 42.831h6.846V44.2h-6.846z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2DCF1",
    d: "M57.161 48.308h6.846v1.369h-6.846z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD8F2",
    d: "M57.161 53.784h6.846v1.369h-6.846z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.072 13.395c.274.959 1.988 1.598 2.844 1.712l-.41-7.188c-.514.114-1.295.399-1.749 1.027-.99 1.369-1.027 3.251-.684 4.45Z",
    fill: "#FED5BC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.456,
    y: 27.429,
    width: 0.685,
    height: 2.396,
    rx: 0.342,
    fill: "#F7D3BF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.087,
    y: 37.355,
    width: 0.685,
    height: 2.396,
    rx: 0.342,
    fill: "#F7CBB2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.087,
    y: 46.939,
    width: 0.685,
    height: 2.396,
    rx: 0.342,
    fill: "#F1C5AC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.456,
    y: 56.523,
    width: 0.685,
    height: 2.396,
    rx: 0.342,
    fill: "#F2C3A9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.503,
    cy: 2.503,
    r: 2.503,
    transform: "rotate(135 11.566 45.089)",
    fill: "#F2F4F8",
    fillOpacity: 0.65
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.863,
    cy: 1.863,
    r: 1.863,
    transform: "rotate(135 6.26 42.198)",
    fill: "#F2F4F8",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.855,
    cy: 62.815,
    r: 1.292,
    transform: "rotate(135 44.855 62.815)",
    fill: "#F2F4F8",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SurveySuccess_svg__a",
    x1: 33.771,
    y1: 7.919,
    x2: 33.771,
    y2: 75.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C95F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SurveySuccess_svg__b",
    x1: 31.404,
    y1: 6.995,
    x2: 31.404,
    y2: 63.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SurveySuccess_svg__c",
    x1: 60.583,
    y1: 28.113,
    x2: 60.583,
    y2: 59.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0DAF0"
  })))));
};
export default SvgSurveySuccess;